import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOpportunitiesreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22 3H2L10 12.46V19L14 21V12.46L22 3Z",
		stroke: "#B5BECA",
		strokeWidth: 1,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgOpportunitiesreact;
